const DESKTOP_SHELL_USER_AGENT_TOKENS = ["EquipeChat-Desktop"];

const hasDesktopShellBridge = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.EquipeChatDesktop?.shell === "desktop";
};

const hasDesktopShellUserAgent = () => {
  if (typeof navigator === "undefined") {
    return false;
  }

  const userAgent = String(navigator.userAgent || "").toLowerCase();

  return DESKTOP_SHELL_USER_AGENT_TOKENS.some((token) =>
    userAgent.includes(String(token || "").toLowerCase())
  );
};

export const isEquipeChatDesktopShell = () =>
  hasDesktopShellBridge() || hasDesktopShellUserAgent();

export default isEquipeChatDesktopShell;
